import { useApp } from 'contexts/app';
import { Paper, Skeleton, Stack, styled, Tag, Text } from 'shell/components';
import { FEEDBACK_LIMIT } from 'utils/constants';

const getDraftProgressDescriptorText = (numStudentSubmissions) => {
    switch (numStudentSubmissions) {
        case 0:
            return 'Submit your first draft to reveal your upgrade path. 🚀';
        case 1:
            return 'Round 2 awaits! Jump into your second draft and level up your assignment! 💪';
        case 2:
            return 'Only one round left! Dive into your final draft and wrap up your assignment with impact! ✨';
        case 3:
            return 'You’re making progress! Keep working on maintaining focus on the main topic. 🎉';
        default:
            return '';
    }
};

const ProgressCard = () => {
    const { studentSubmissions } = useApp();

    const numStudentSubmissions = studentSubmissions?.length ?? 0;
    const draftProgressDescriptorText = getDraftProgressDescriptorText(numStudentSubmissions);

    return (
        <CustomPaper>
            <Stack spacing={3}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text weight={'medium'}>Your Draft Progress</Text>
                    <Tag type={'attempts'} value={FEEDBACK_LIMIT - numStudentSubmissions} />
                </Stack>
                <Text>
                    {draftProgressDescriptorText || (
                        <>
                            <Skeleton />
                            <Skeleton width={'60%'} />
                        </>
                    )}
                </Text>
            </Stack>
        </CustomPaper>
    );
};

const CustomPaper = styled(Paper)(({ theme }) => {
    return {
        maxWidth: '325px',
        height: 'fit-content',
        padding: theme.spacing(3),
    };
});

export default ProgressCard;
